"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_USER_ZONE = exports.GET_CURRENT_LOCATION = exports.DEFAULT_LOCATION = exports.CURRENT_LOCATION = void 0;
const DEFAULT_LOCATION = exports.DEFAULT_LOCATION = 'getDefaultLocation';
const GET_CURRENT_LOCATION = exports.GET_CURRENT_LOCATION = 'getCurrentLocation';
const CURRENT_LOCATION = exports.CURRENT_LOCATION = 'getCurrentLocation';
const GET_USER_ZONE = exports.GET_USER_ZONE = 'getUserZone';